<template>
  <view class="ts-navbar externClass extern-class" wx:style="{{computedNavbarStyle}}">
    <view class="ts-navbar-left" bindtap="clickLeft" wx:style="{{{color: leftColor}}}">
      <Icon name="navbar-back" color="#000" size="40" wx:if="{{leftArrow}}" />
      <text class="ts-navbar-left-text" wx:if="{{left}}">{{ left }}</text>
      <slot wx:else name="left"></slot>
    </view>
    <view class="ts-navbar-title" wx:style="{{titleStyle}}">
      <text class="ts-navbar-text" wx:if="{{title}}">{{ title }}</text>
      <slot wx:else></slot>
    </view>
    <view class="ts-navbar-right" bindtap="clickRight">
      <text wx:if="{{right}}">{{ right }}</text>
      <slot wx:else name="right"></slot>
    </view>
  </view>
</template>

<script>
  import mpx, { createComponent } from '@mpxjs/core'
  import { is, goback, bridge } from '@didi/spring-base'
  function getSafeAreaInsetTop(statusBarHeight) {
    if (statusBarHeight >= 0) {
      const SBHinCSSPixels =
        window?.devicePixelRatio > 0 ? statusBarHeight / window.devicePixelRatio : 2
      const safeAreaInsetTop = Math.round(SBHinCSSPixels * 2.2)
      return safeAreaInsetTop
    } else {
      return 0
    }
  }

  createComponent({
    externalClasses: ['extern-class'],
    options: {
      multipleSlots: true
    },
    props: {
      left: {
        type: String,
        value: ''
      },
      title: {
        type: String,
        value: ''
      },
      right: {
        type: String,
        value: ''
      },
      leftColor: {
        type: String,
        value: ''
      },
      leftArrow: {
        type: Boolean,
        value: true
      },
      fullScreen: {
        type: Boolean,
        value: false
      },
      leftIconSize: {
        type: Number,
        optionalTypes: [String],
        value: 25
      },
      useDefaultBack: {
        type: Boolean,
        value: true
      },
      navbarStyle: {
        type: Object,
        value: {}
      },
      titleStyle: {
        type: Object,
        value: {}
      },
      dropdownStyle: {
        type: Object,
        value: {}
      },
      isDropdown: {
        type: Boolean,
        value: false
      },
      isFixed: {
        type: Boolean,
        value: false
      }
    },
    computed: {
      computedNavbarStyle() {
        let style = this.isDropdown ? this.dropdownStyle : this.navbarStyle
        this.isFixed &&
          (style = {
            ...style,
            position: 'fixed',
            top: 0,
            left: 0
          })
        const _style =
          is('mini') && is('wx')
            ? {
                paddingTop: this.safeAreaTop + 'px',
                ...style
              }
            : is('android')
            ? {
                paddingTop: this.safeAreaTop / 2 + 'px',
                ...style
              }
            : style

        return _style
      }
    },
    ready() {
      if (this.fullScreen) {
        if (is('passenger')) {
          bridge.hideNativeBar({}, (res) => {
            this.safeAreaTop = res?.safeAreaInsetTop || getSafeAreaInsetTop(res.statusBarHeight) || 0
          })
        }

        if (is('mini') && is('wx')) {
          const windowInfo = wx.getWindowInfo()
          this.safeAreaTop = windowInfo?.statusBarHeight || 0
        }
      }
    },
    data: {
      safeAreaTop: 0
    },
    methods: {
      clickLeft() {
        this.triggerEvent('clickleft')
        if (!this.useDefaultBack) {
          return
        }
        goback()
      },
      clickRight() {
        this.triggerEvent('clickright')
      }
    }
  })
</script>

<style lang='stylus' scoped>
  .ts-navbar
    position relative
    display flex
    width 100%
    box-sizing content-box
    padding-top env(safe-area-inset-top)
    align-items center
    justify-content center
    height 44px
    z-index 1
    text-align center
    background-color #fff
    user-select none
    line-height 20px
    &-left
      position absolute
      left 0
      display flex
      align-items center
      padding 0 16px
      font-size 25px
      &-text
        font-size 16px
    &-title
      flex 1
      flex-shrink 0
      width 0
      max-width 60%
      text-overflow ellipsis
      overflow hidden
      white-space nowrap
      font-family PingFangSC-Semibold
      font-weight 500
      font-size 18px
    &-text
      flex 1
      width 0
      overflow hidden
      white-space nowrap
      text-overflow ellipsis
    &-right
      position absolute
      right 0
      display flex
      align-items center
      padding 0 16px
      font-size 14px
</style>

<script name='json'>
  module.exports = {
    component: true,
    usingComponents: {
      'Icon': '@didi/spring-icon'
    }
  }
</script>

